import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportServiceLevelPageRoutingModule } from './report-service-level-routing.module';

import { ReportServiceLevelPage } from './report-service-level.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportServiceLevelPageRoutingModule,
    NgxDatatableModule,
  ],
  declarations: [ReportServiceLevelPage]
})
export class ReportServiceLevelPageModule {}
